import { CAMERA_FRUSTUM, CAMERA_Z, getBaseZoom } from "@/constants";
import { OrthographicCamera } from "@react-three/drei";
import { useThree } from "@react-three/fiber";

export const Camera = () => {
  const { size } = useThree();

  return (
    <OrthographicCamera
      makeDefault
      position={[0, 0, CAMERA_Z]}
      zoom={getBaseZoom(size.height)}
      near={CAMERA_FRUSTUM.near}
      far={CAMERA_FRUSTUM.far}
    />
  );
};
